import { useEffect, useMemo, useRef } from "react";
import {
  getSelectedValue,
  getValueAtrr,
  toSelectOptions,
} from "./utils/common";
import "./css/SelectField.css";
export default function SelectField({
  id,
  name,
  className,
  label,
  value,
  onChange,
  options,
  valueAttr,
  labelAttr,
  emptyLabel,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  ...props
}) {
  const inputRef = useRef();
  const handleChange = useMemo(
    () => (event) => {
      if (event.target === inputRef.current) {
        if (onChange instanceof Function) {
          onChange(event);
        }
      } else {
        event.stopPropagation();
      }
    },
    [onChange],
  );
  const handleSelectChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const value = getSelectedValue(options, event.target.value, valueAttr);
    inputRef.current.name = name;
    inputRef.current.value = value;
    inputRef.current.dispatchEvent(
      new Event("change", { bubbles: true, cancelable: true, composed: false }),
    );
  };
  const computedClassName = [
    "form-group",
    "select-field",
    isInvalid ? "has-error" : "",
    ...((!!className && className.split(" ")) || []),
  ]
    .join(" ")
    .trim();
  const computedOptions = useMemo(() => {
    return toSelectOptions(options, labelAttr, valueAttr);
  }, [options, labelAttr, valueAttr]);
  useEffect(() => {
    const input = inputRef.current;
    const onChange = handleChange;
    if (!!input) {
      input.addEventListener("change", onChange);
      return () => {
        input.removeEventListener("change", onChange);
      };
    }
  }, [handleChange]);
  return (
    <div id={id} className={computedClassName} {...props} ref={inputRef}>
      {!!label && (
        <label
          for={`${id}_select`}
          style={labelStyle}
          className="control-label"
        >
          {label}
        </label>
      )}
      <select
        id={`${id}_select`}
        value={getValueAtrr(value, valueAttr)}
        className="form-control"
        onInput={handleSelectChange}
        aria-invalid={isInvalid}
        disabled={disabled}
      >
        {!!emptyLabel && <option value="">{emptyLabel}</option>}
        {computedOptions.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

SelectField.defaultProps = {
  className: "",
  value: "",
};
